import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Cómo recibo el producto después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un email con el link de descarga de todos los archivos. Es automático, sin esperas ni intervención manual. Podés descargar desde el celular, tablet o computadora. El acceso es tuyo para siempre.'
}, {
  q: '¿Sirve si nunca vendí nada o recién arranco?',
  a: 'Sí, especialmente para vos. El sistema fue diseñado para quien arranca desde cero. El lenguaje es directo, sin tecnicismos, con ejemplos en pesos argentinos actuales. Si ya tenés algo de experiencia, igualmente encontrás herramientas y sistemas para hacer crecer lo que ya tenés.'
}, {
  q: '¿Necesito inversión grande para aplicar el sistema?',
  a: 'No. La Guía 1 explica cómo arrancar con menos de $50.000. El sistema está diseñado para que cada peso rinda al máximo. Con un celular, Instagram y un espacio en tu casa ya podés arrancar.'
}, {
  q: '¿Qué diferencia hay entre los 3 packs?',
  a: 'Los 3 packs incluyen las 8 guías completas. La diferencia está en los bonos. El Pack Inicial no incluye bonos. El Pack Pro suma los Bonos 1 y 2 (las 30 preguntas y respuestas + la calculadora de precios). El Pack Full Access suma los 8 bonos completos: textos para Instagram, directorio de proveedores, guión de ventas por DM, checklist de lanzamiento, shooting con celular y calendario de 30 días.'
}, {
  q: '¿Sirve si estoy en el interior del país?',
  a: 'Sí. El sistema fue pensado para emprendedoras de las 23 provincias. El Bono 4 incluye proveedores online que hacen envíos a todo el país, y todas las estrategias de Instagram y WhatsApp funcionan sin importar dónde estés.'
}, {
  q: '¿Qué diferencia tiene con tutoriales gratis en YouTube?',
  a: 'YouTube te da tips sueltos sin orden ni conexión entre sí. El MEGAPACK es un sistema completo con un camino lógico de aplicación, ejemplos en pesos argentinos actuales, herramientas listas para usar y un mapa claro de la primera compra a la marca propia. No perdés horas buscando — abrís la guía del punto donde estás y aplicás.'
}, {
  q: '¿Por qué elegir el Pack Pro o el Full Access?',
  a: 'El Pack Inicial te da el sistema completo y es suficiente para arrancar. El Pack Pro suma la calculadora de precios y el banco de respuestas — los dos bonos que más impacto inmediato tienen. El Full Access suma todos los bonos restantes: textos ya escritos, directorio curado, guión de DM, checklist y calendario. Si querés arrancar sin improvisar nada desde el día uno, el Full Access es la opción más completa.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí, 7 días completos. Si sentís que no cumplió lo que prometimos, te devolvemos el 100% del dinero sin preguntas y sin formularios. Nuestra tasa de devoluciones es menor al 1% porque el sistema funciona.'
}, {
  q: '¿Puedo pagar en cuotas?',
  a: 'Sí. El checkout acepta tarjetas de crédito con las cuotas disponibles en tu banco y Mercado Pago. Las opciones de cuotas dependen del medio de pago que uses.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full py-10 sm:py-20" data-id="element-54">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-8 sm:mb-12" data-id="element-56">
          <p className="text-gold text-xs sm:text-sm tracking-widest mb-3 sm:mb-4" data-id="element-57">
            DUDAS COMUNES
          </p>
          <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-white" data-id="element-58">
            PREGUNTAS FRECUENTES
          </h2>
        </motion.div>

        <div className="space-y-3 sm:space-y-4" data-id="element-59">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className={`border rounded-lg overflow-hidden transition-colors duration-300 ${openIndex === index ? 'bg-violet-rich/40 border-gold/40' : 'bg-violet-deep/60 border-gold/20 hover:border-gold/40'}`} data-id="element-60">
              <motion.button whileTap={{
            scale: 0.99
          }} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 py-4 sm:px-6 sm:py-5 flex items-center justify-between text-left" data-id="element-61">
                <span className="text-white font-semibold text-sm sm:text-base pr-4" data-id="element-62">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-63" />
              </motion.button>

              <AnimatePresence data-id="element-64">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-65">
                    <div className="px-4 sm:px-6 pb-4 sm:pb-5 border-t border-gold/10 pt-3 sm:pt-4" data-id="element-66">
                      <p className="text-violet-100/80 text-xs sm:text-sm leading-relaxed" data-id="element-67">
                        {faq.a}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}